import { TYPE_BITEL_REVENUE, TYPE_BITEL_AIRTIME } from "./type";

const initialState = {
  revenue: [],
};

export const reducerBitel = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_BITEL_REVENUE:
      return {
        ...state,
        revenue: action.payload,
      };
    default:
      return state;
  }
};

export const reducerAirtimeBitel = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_BITEL_AIRTIME:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};
